'use client';

import { TypeContentTitle } from '../types/home.type';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from '@/components/ui/carousel';
import * as React from 'react';
import Autoplay from 'embla-carousel-autoplay';
import ContentBodyCom from '../ContentBodyCom';
import { FaAnglesLeft, FaAnglesRight } from 'react-icons/fa6';
// import { Badge } from "@/components/ui/badge";
// import Link from "next/link";

export default function ClinicCard({
    contentBodydata,
    title,
    sub_title,
    center,
}: TypeContentTitle) {
    const plugin = React.useRef(
        Autoplay({
            delay: 3000,
            stopOnMouseEnter: true,
            stopOnInteraction: true,
            stopOnFocusIn: true,
        }),
    );

    return (
        <div className="grid">
            <div className="text-center">
                <p className="text-2xl font-bold text-[#222222]">{title}</p>
                <p className="font-medium pt-1">{sub_title}</p>
                <hr className="mt-2 w-full smp:!mb-0 mb-5" />
            </div>
            <div className="overflow-x-hidden">
                <Carousel
                    plugins={[plugin.current]}
                    opts={{
                        direction: 'rtl',
                    }}
                    onBlur={() => plugin.current.play()}
                    className="w-full px-10"
                >
                    <CarouselContent
                        className="pt-[60px]"
                        onBlur={() => plugin.current.play()}
                    >
                        {contentBodydata.map((i) => (
                            <CarouselItem
                                key={i.id}
                                className="py-2"
                                style={{ flexBasis: 'auto' }}
                            >
                                <ContentBodyCom
                                    center={Boolean(center)}
                                    key={i.id}
                                    data={i}
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious
                        icon={<FaAnglesLeft />}
                        className="text-[#222222] !top-[70%] !p-2 !bg-[#f3f3f9] !rounded-full hover:!text-[#222222] !shadow-none hover:!opacity-50 transition-opacity text-base smp:!text-[1.4rem] !border-0 left-0 disabled:!opacity-50"
                        invert
                    />
                    <CarouselNext
                        icon={<FaAnglesRight />}
                        className="text-[#222222] !top-[70%] !p-2 !bg-[#f3f3f9] !rounded-full !shadow-none hover:!text-[#222222] hover:!opacity-50 transition-opacity text-base smp:!text-[1.4rem] !border-0 right-0 disabled:!opacity-50"
                        invert
                    />
                </Carousel>
            </div>
        </div>
    );
}
